import { Controller, useFormContext } from 'react-hook-form';
import { RadioCardGroup, type RadioCardOption } from '../components/RadioCardGroup';
import type { SignupFormValues } from '../schema';

type Faturamento = SignupFormValues['faturamento'];

const OPTIONS: ReadonlyArray<RadioCardOption<Faturamento>> = [
  { value: 'ATE_500K', label: 'Até R$ 500 mil', description: 'Receita anual da empresa' },
  { value: 'ENTRE_500K_2M', label: 'R$ 500 mil – R$ 2 mi' },
  { value: 'ENTRE_2M_10M', label: 'R$ 2 mi – R$ 10 mi' },
  { value: 'ENTRE_10M_50M', label: 'R$ 10 mi – R$ 50 mi' },
  { value: 'ACIMA_50M', label: 'Acima de R$ 50 mi' },
];

export const Step09Faturamento = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext<SignupFormValues>();

  return (
    <Controller
      control={control}
      name="faturamento"
      render={({ field }) => (
        <RadioCardGroup<Faturamento>
          label="Faturamento anual"
          value={field.value}
          onChange={field.onChange}
          options={OPTIONS}
          columns={2}
          errorMessage={errors.faturamento?.message}
        />
      )}
    />
  );
};
